// Affected-categories card on the paid report page. Verbatim from
// PaidReport.jsx (W2c). Mirrors the preview's PreviewCategories shape
// but with `paid-report-*` test-ids so funnel queries and Playwright
// selectors stay distinct between Preview vs Report pages.
export default function ReportCategories({
  leakCategoriesAffected,
  estimatedMonthlyLossMin,
  estimatedMonthlyLossMax,
}) {
  if (!leakCategoriesAffected || leakCategoriesAffected.length === 0) return null;
  return (
    <div className="sf-card" style={{ marginBottom: 28 }} data-testid="paid-report-categories-card">
      <div className="sf-eyebrow" style={{ marginBottom: 14 }}>Affected categories</div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {leakCategoriesAffected.map((c) => (
          <span
            key={c.id}
            className="sf-mono"
            style={{
              fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase",
              border: "1px solid var(--sf-gold-dim)", color: "var(--sf-gold)",
              padding: "6px 10px", borderRadius: 999,
              backgroundColor: "rgba(201,162,74,0.05)",
            }}
          >
            {c.name} &middot; {String(c.severity || "").toUpperCase()} EXPOSURE
          </span>
        ))}
      </div>
      {(estimatedMonthlyLossMin || estimatedMonthlyLossMax) && (
        <div
          data-testid="paid-report-categories-combined-loss"
          className="sf-mono"
          style={{
            marginTop: 22, paddingTop: 18, borderTop: "1px dashed #22262B",
            fontSize: 13, color: "var(--sf-offwhite)", lineHeight: 1.55,
          }}
        >
          <span style={{ color: "var(--sf-muted)" }}>
            {leakCategoriesAffected.length} {leakCategoriesAffected.length === 1 ? "system" : "systems"} contributing to an estimated
          </span>{" "}
          <span className="sf-gold">
            ${estimatedMonthlyLossMin?.toLocaleString?.() ?? 0}–${estimatedMonthlyLossMax?.toLocaleString?.() ?? 0}
          </span>{" "}
          <span style={{ color: "var(--sf-muted)" }}>
            in monthly revenue loss. Low end is conservative; high end assumes the gaps stay open.
          </span>
        </div>
      )}
    </div>
  );
}
